export const verticalBreakpoints = {
  xs: "@media (min-height: 0px)",
  lg: "@media (min-height: 768px)",
};
export const vB = verticalBreakpoints;
export const sal = () =>
  getComputedStyle(document.documentElement).getPropertyValue("--sal");
